export var UserSettingsActionKind;
(function (UserSettingsActionKind) {
    UserSettingsActionKind["UpdateUser"] = "UpdateUser";
    UserSettingsActionKind["UpdateHolidayYear"] = "UpdateHolidayYear";
    UserSettingsActionKind["RefreshUserData"] = "RefreshUserData";
})(UserSettingsActionKind || (UserSettingsActionKind = {}));
